import React, { Component } from 'react';
import { currency } from './../../../helpers/';

class ItemBundles extends Component {

	addToBasket(){
		return (
			<ul className="buttons-right">
				<li>
					<button type="button" className="btn btn-primary btn-block" onClick={ this.props.onAddToCartClicked }>
						<span className="icon"><i className="fa fa-cart-plus fa-left"></i></span>
						<span className="label">Add To Basket</span>
					</button>
				</li>
			</ul>
		);
	}

	inBasket(){
		return (
			<div className="brand-color">
				<i className="fa fa-shopping-cart"></i>
				<strong>In Basket</strong>
			</div>
		);
	}

	render() {

		const price = currency.convert( this.props.item.price.value );
		const currencySign = price.substring( 0, 1 );

		return (
			<div className="border padding-xy">
				<div className="row">
					<div className="col-xs-12 col-sm-8 col-md-9">
						<h2 className="h2 brand-color">{ this.props.item.name }</h2>
						<p className="p-tag hidden-xs">Description: no data pulled down for now - remove later. { this.props.description } visible on large</p>
					</div>
					<div className="col-xs-12 col-sm-4 col-md-3 text-right">
						<div className="brand-color margin-none bundle-price currency-bolt-on">{ currencySign }</div>
						<div className="bundle-price margin-half-bottom">{ price }</div>
						{ !this.props.purchased ? this.addToBasket.call( this ) : this.inBasket() }
					</div>
					<div className="col-xs-12 visible-xs-block">
						<hr/>
						<p className="p-tag">Description: no data pulled down for now - remove later. { this.props.description } visible on xs</p>
					</div>
				</div>
			</div>
		);
	};
}

export default ItemBundles;



// WEBPACK FOOTER //
// src/client/components/common/transactions/ItemBoltOn.js